import { IUseHeaderResponse } from "@/layouts/general/hooks/useHeader";
import { Path } from "@/navigations/routes";
import Link from "next/link";
import React from "react";
import ButtonLinkNext from "@sendsprint/ui-react/components/buttonLinkNext";
import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
} from "@sendsprint/ui-react/shadcn/navigation-menu";

interface Props {
  headerLogic: IUseHeaderResponse;
  showWhite?: boolean;
}

const DesktopNavigation = ({ headerLogic, showWhite }: Props) => {
  const { loginLink, registerLink, handleClearCampaignId } = headerLogic;

  return (
    <NavigationMenu viewport={false} className="ss:hidden ss:lg:flex">
      <NavigationMenuList className="ss:gap-8 ss:items-center">
        <NavigationMenuItem>
          <NavigationMenuLink asChild>
            <Link className="ss:font-medium" href={`${Path.Home}#faq`}>
              FAQs
            </Link>
          </NavigationMenuLink>
        </NavigationMenuItem>
        <NavigationMenuItem>
          <NavigationMenuLink asChild>
            <Link className="ss:font-medium" href={Path.AboutUs}>
              About us
            </Link>
          </NavigationMenuLink>
        </NavigationMenuItem>
        <NavigationMenuItem>
          <NavigationMenuLink asChild>
            <Link
              className="ss:font-medium"
              target="_blank"
              href={loginLink}
              onClick={handleClearCampaignId}
            >
              Log in
            </Link>
          </NavigationMenuLink>
        </NavigationMenuItem>
        <NavigationMenuItem>
          <ButtonLinkNext
            href={registerLink}
            onClick={handleClearCampaignId}
            label="Register"
            size="small"
            radius="full"
            className="ss:px-6!"
            variant={showWhite ? "white" : "primary"}
          />
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  );
};

export default DesktopNavigation;
